import { useCallback } from 'react'
import { supabaseGetter } from "~/api/supabase-getter"
import { useUpdateCrop } from "~/api/supabase-mutations"
import _ from 'lodash';

export const useAssignCrops = ({ cropIds }) => {
  const { updateCrop } = useUpdateCrop()

  const assignCrops = useCallback(async ({ orgId }) => {
    await Promise.all(cropIds.map(cropId => {
      return updateCrop(
        cropId,
        { organization_id: orgId },
        {
          onSuccess: () => {},
          onError: (crop) => console.log('Failed updating crop record', crop)
        }
      )
    }))

    // Invalidate caches and notify listeners to refetch
    // Crops and organizations are used by crop lists and timeline views
    supabaseGetter.crops.invalidate()
    supabaseGetter.organizations.invalidate()
  }, [cropIds, updateCrop])

  return { assignCrops }
}